import conn from "@/store/utils/connection";
import resulter from "@/store/utils/resulter";
import api from "../apiEndPoint";
import transaksiAPI from "@/store/utils/api-route/transaksiAPI";

export default {
	getQueryStringIndex: ({rootGetters, getters}, {key}) => {
		let getFilter = rootGetters["filterGlobalModule/getFilter"];
		let getFilterItem = rootGetters["filterGlobalModule/getFilterItem"];

		let query = {
			key,
			sort_by: getFilter.sortBy,
			order_by: getFilter.orderBy,
			limit: getters.pagination.limit,
			offset: getters.pagination.offset,
		};

		Object.keys(getFilterItem).forEach((key) => {
			if (getFilterItem[key].length > 0) {
				switch (key) {
					case "akunSettlement":
						query.idrekening_owner = getFilterItem[key];
						break;
					case "providerEdc":
						query.idprovider = getFilterItem[key];
						break;
					case "outlet":
						query.idoutlet = getFilterItem[key];
						break;
					case "statusKonfirmasi":
						query.status_konfirmasi = getFilterItem[key].map(v => v?.toString())
						break;
					case "karyawan":
						query.idkaryawan = getFilterItem[key]
						break;
				}
			}

			if (key === "periode") {
				query.filter_by = getFilterItem[key].filterBy;
				if (getFilterItem[key].filterBy === "periode") {
					query.tanggal_awal = getFilterItem[key].startDate;
					query.tanggal_akhir = getFilterItem[key].endDate;
				}

				if (getFilterItem[key].filterBy === "tahun") {
					query.tahun = getFilterItem[key].year.toString();
				}
				if (getFilterItem[key].filterBy === "bulan") {
					query.bulan = getFilterItem[key].month.toString();
				}
			}
		});

		return query;
	},

	getListOutlet: ({commit, dispatch}, loadProvider = true) => {
		conn.get(api.getListOutlet)
			.then((res) => {
				let {code, data, status, msg} = res.data;
				if (code === 200) {
					if (status) {
						commit("setListOutlet", data);
					} else {
						commit("setResponse", resulter.errorResult(msg));
					}

					if (loadProvider) {
						dispatch("getListProvider");
					}
				}
			})
			.catch((e) => {
				commit("setResponse", resulter.errorResult(e));
			});
	},
	getListProvider: ({commit, dispatch}, loadSettlement = true) => {
		conn.get(api.getListProvider)
			.then((res) => {
				let {code, data, status, msg} = res.data;
				if (code === 200) {
					if (status) {
						commit("setListProvider", data);
					} else {
						commit("setResponse", resulter.errorResult(msg));
					}

					if (loadSettlement) {
						dispatch("getListSettlement");
					}
				}
			})
			.catch((e) => {
				commit("setResponse", resulter.errorResult(e));
			});
	},
	getListSettlementEdc: ({commit, dispatch}, payload) => {
		dispatch("getQueryStringIndex", payload)
			.then((query) => {
				commit("setFetching", true);
				conn.get(api.getListSettlementEdc, query).then((res) => {
					let {code, data, status, msg} = res.data;
					if (code === 200) {
						conn.setQueryString(query);
						if (status) {
							commit("setListSettlementEdc", data.list);
							commit("setCountData", data.length);
							commit("setResponse", resulter.successResult(msg));
							commit("setEndItemOfPage", data.list[data.list.length - 1]);
							commit("setNextPagination", data);
						} else {
							commit("setResponse", resulter.errorResult(msg));
						}
					}
					commit("setFetching", false);
				});
			})
			.catch((e) => {
				commit("setFetching", false);
				commit("setResponse", resulter.errorResult(e));
			});
	},

	async exportData({commit, dispatch}, payload) {
		try {
			let query = await dispatch("getQueryStringIndex", payload)
			let formData = new FormData
			formData.append("type", "riwayat_settlement_edc")
			formData.append("filter_json", JSON.stringify(query))

			const res = await conn.post(transaksiAPI.export.job, formData, conn.contentType.form)
			if (!res.data) {
				throw(res)
			}
			if (res.data.code === 200) {
				localStorage.setItem("key_export_settlement_edc_global", "export:job:keuangan:riwayatsettlement")
				return resulter.successResult(res.data.msg)
			} else {
				return resulter.errorResult(res.data.msg, res.data.data)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	async exportTracker({commit}) {
		try {
			let keyExport = localStorage.getItem("key_export_settlement_edc_global")
			if (keyExport === null) {
				return resulter.errorResult()
			}
			let query = {
				key: keyExport,
			}
			const res = await conn.get(transaksiAPI.export.track, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.code === 200) {
				return resulter.successResult(res.data.msg, res.data.data)
			} else {
				return resulter.errorResult(res.data.msg, res.data.data)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	async exportDeleteCluster({commit}, key) {
		try {
			let query = {
				key: key
			}
			const res = await conn.get(transaksiAPI.export.delete.cluster, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.code === 200) {
				return resulter.successResult(res.data.msg, res.data.data)
			} else {
				return resulter.errorResult(res.data.msg, res.data.data)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	async exportDeleteMaster({commit}) {
		try {
			let keyExport = localStorage.getItem("key_export_settlement_edc_global")
			let query = {
				key: keyExport
			}
			const res = await conn.get(transaksiAPI.export.delete.master, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.code === 200) {
				localStorage.removeItem("key_export_settlement_edc_global")
				return resulter.successResult(res.data.msg, res.data.data)
			} else {
				return resulter.errorResult(res.data.msg, res.data.data)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	}
};
